import { ReadingJournalPositionType } from "features/ReadingJournal/types";
import ReadingJournalPositionSeconds from "./ReadingJournalPositionSeconds";
import ReadingJournalPositionPages from "./ReadingJournalPositionPages";

export default function ReadingJournalPosition({
  position,
}: {
  position: ReadingJournalPositionType | null;
}) {
  if (!position || !position?.value) return null;

  if (position.type === "seconds") {
    return <ReadingJournalPositionSeconds position={position} />;
  }

  if (position.type === "pages") {
    return <ReadingJournalPositionPages position={position} />;
  }

  return null;
}
